import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const EnableShopButtons = ({
  isEnrolmentEnabled,
  saving,
  showBenefits,
  showWellness,
  doCheckout,
  hasShop,
  canCheckout,
  checkoutDisabled,
  errorText,
  isCartEmpty = false,
}) => {
  const enrolmentButton =
    isEnrolmentEnabled &&
    <Button type="button" disabled={saving} onClick={showBenefits} secondary>
      <FormattedMessage {...messages.editSelectionDescription} />
    </Button>;
  const wellnessButton =
    hasShop &&
    <Button type="button" disabled={saving} onClick={showWellness} secondary>
      <FormattedMessage {...messages.continueShoppingDescription} />
    </Button>;
  const errorComponent =
    errorText &&
    !saving &&
    <p>
      {" "}{errorText}{" "}
    </p>;
  const checkoutButton =
    canCheckout &&
    <Button
      type="button"
      onClick={() => doCheckout(canCheckout)}
      submitting={saving}
      disabled={checkoutDisabled}
    >
      <FormattedMessage {...messages.checkOutDescription} />
    </Button>;

  return (
    <div>
      {isCartEmpty &&
        <p>
          <FormattedMessage {...messages.shoppingCartEmptyDescription} />
        </p>}
      {checkoutButton}
      {enrolmentButton}
      {wellnessButton}
      {errorComponent}
    </div>
  );
};
EnableShopButtons.propTypes = {
  isEnrolmentEnabled: PropTypes.bool,
  saving: PropTypes.bool,
  showBenefits: PropTypes.any,
  showWellness: PropTypes.any,
  doCheckout: PropTypes.any,
  hasShop: PropTypes.any,
  canCheckout: PropTypes.any,
  checkoutDisabled: PropTypes.any,
  errorText: PropTypes.any,
  isCartEmpty: PropTypes.any,
};

export default EnableShopButtons;



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/enableShopButtons.jsx